<div class="flex-column h-100">
  <odx-content-box>
    <div odxLayout="flex">
      @if (selectedGas) {
        <h6 class="odx-title-6 header-prefix" i18n="@@flameDetectorConfiguration.familySelector.headerPrefix">
          Brandmelder-Familie für {{ selectedGas | localizeGasName }}
        </h6>
      }
    </div>
  </odx-content-box>

  <div class="configuration-wizard-header flex-column space-top">
    <h5
      class="odx-title-5"
      i18n="@@flameDetectorConfiguration.familySelector.header"
      data-testid="flameDetectorConfiguration.familySelector.header"
    >
      Brandmelder-Familie auswählen
    </h5>
  </div>

  <odx-content-box class="flex-column flex-scroll" odxLayout="flex">
    @if (selectableFamilyTypes.length > 0) {
      <form [formGroup]="selectedFamilyForm" class="overflow-hidden h-100">
        <odx-radio-group formControlName="selectedType" required="true" class="overflow-hidden h-100">
          <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100 mb-36">
            @for (family of selectableFamilyTypes; track family) {
              <app-picture-card
                class="overflow-hidden"
                title="{{ family.name }}"
                i18n-title="@@flameDetectorConfiguration.familySelector.pictureCardTitle"
                [isSelected]="selectedFamilyForm.value.selectedType === family"
                [imageUrl]="ProductImage.getCantoSourceUrl(family.cantoImageId)"
                (click)="select(family)"
              >
                <odx-radio-button (click)="$event.stopPropagation()" [value]="family" i18n="@@global.select"
                  >Auswählen</odx-radio-button
                >
              </app-picture-card>
            }
          </div>
        </odx-radio-group>
      </form>
    } @else {
      <app-refresh-products-hint dataType="Flammendetektor" i18n-dataType="@@global.flameDetectors"></app-refresh-products-hint>
    }
  </odx-content-box>
</div>
